import instance from "./axios";

class ProjectServices {
  getAll = () => instance.get("api/project/getallprojects");
}

export default new ProjectServices();
